// dependencies.
import { get } from 'lodash'

// detect the base URL.
const SPA_VERSION = get(process.env, 'SPA_VERSION')

/**
 * detect the api base URL
 */
export default SPA_VERSION



// WEBPACK FOOTER //
// ./src/plugins/http/version.js